<script setup lang="ts">
withDefaults(defineProps<{
  text: string;
  icon: string;
  iconColor?: string;
  textDirection?: string;
}>(), {
  iconColor: 'text-blue-500',
});
</script>
<template>
  <div class="flex flex-1 flex-row">
    <hfc-icon :icon="icon" class="text-2xl mt-1" :class="iconColor" />
    <hfc-icon :icon="icon" class="text-2xl mt-1 -ml-2 mr-2" :class="iconColor" />
    <div class="text-left" v-html="text"></div>
  </div>
</template>
